import AppDispatcher from '../../dispatcher/AppDispatcher';
import FavouritesConstants from '../../constants/FavouritesConstants';
import AccountParser from '../../parsers/AccountParser';
import AccountsApiUtils from '../../utils/AccountsApiUtils';

//TODO: move to utils directory
const raise = (actionType, data) => {
  AppDispatcher.handleViewAction({
    actionType,
    data,
  });
};

class FavouritesActionCreator {
  // View Actions
  /**
   * Action to get all accounts from API
   */
  getAccountsList() {
    AppDispatcher.handleViewAction({
      actionType: FavouritesConstants.REQUEST_FAVOURITE_ACCOUNTS,
    });
  }

  getQuickLinkPermissions() {
    AppDispatcher.handleViewAction({
      actionType: FavouritesConstants.REQUEST_QUICKLINK_PERMISSIONS,
    });
  }

  handleQuickLinkPermissionSuccess(response) {
    AppDispatcher.handleServerAction({
      actionType: FavouritesConstants.REQUEST_QUICKLINK_PERMISSIONS_SUCCESS,
      data: response,
    });
  }

  /**
   * Action to get accounts with Ids from API
   */
  getAccountDetails(accountId) {
    AppDispatcher.handleServerAction({
      actionType: FavouritesConstants.REQUEST_ACCOUNT_DETAILS,
      data: accountId,
    });
  }

  setAccountID(id) {
    AppDispatcher.handleServerAction({
      actionType: FavouritesConstants.SET_ACCOUNT,
      id,
    });
  }

  getTermsAndConditions() {
    AppDispatcher.handleServerAction({
      actionType: FavouritesConstants.REQUEST_TERMS_AND_CONDITIONS,
    });
  }

  /**
   * Action to handle an API accounts deatils success
   */
  handleAccountsDetailsSuccess(response) {
    const accountParser = new AccountParser();
    const accountDetails = accountParser.parseAccountDetailResponse(response);
    AppDispatcher.handleServerAction({
      actionType: FavouritesConstants.REQUEST_ACCOUNT_DETAILS_SUCCESS,
      data: accountDetails,
    });
  }

  /**
   * Action to handle error in API call of account details
   */

  handleAccountsDetailsError(id, error, status) {
    AppDispatcher.handleServerAction({
      actionType: FavouritesConstants.REQUEST_ACCOUNT_DETAILS_ERROR,
      data: error,
      errCode: status,
      id,
    });
  }

  /**
   * Action to success of Accept Terms and Conditions
   */
  handleAcceptTcSuccess() {
    AppDispatcher.handleServerAction({
      actionType: FavouritesConstants.REQUEST_ACCEPT_TC_SUCCESS,
    });
  }

  handleDangerPeriodDataSuccess(response, accid, status) {
    AppDispatcher.handleServerAction({
      actionType: FavouritesConstants.REQUEST_DANGER_PERIOD_SUCCESS,
      data: response,
      id: accid,
      status,
    });
  }

  /**
   * Action to handle success in the pots details
   */
  handlePotDataSuccess(response, accid) {
    AppDispatcher.handleServerAction({
      actionType: FavouritesConstants.REQUEST_REJIG_POT_DETAILS_SUCCESS,
      data: response,
      id: accid,
    });
  }

  resetRejigIconSavingsPots(response, accid) {
    AppDispatcher.handleServerAction({
      actionType: FavouritesConstants.REQUEST_RESET_REJIG_ICON,
      data: response,
      id: accid,
    });
  }
  /**
   * For account rename now only
   */
  updateAccountsStore(response) {
    AppDispatcher.handleViewAction({
      actionType: FavouritesConstants.RENAME_ACCOUNT,
      data: response,
    });
  }

  requestBalance() {
    const balance_data = {
      file_type: 'csv',
    };
    AccountsApiUtils.requestBalance(balance_data);
  }

  addSelectedAccount(account) {
    const accountParser = new AccountParser();
    const parsedAccount = accountParser.parseFromFavouriteAccount(account);
    raise(FavouritesConstants.ADD_SELECTED_ACCOUNT, parsedAccount);
  }

  getFavouriteAccounts() {
    raise(FavouritesConstants.REQUEST_FAVOURITE_ACCOUNTS);
  }

  handleAccountsListSuccess(response) {
    const accountParser = new AccountParser();
    raise(FavouritesConstants.REQUEST_FAVOURITE_ACCOUNTS_SUCCESS, {
      accountList: accountParser.parseAccountListResponse(response),
      totalNumberOfAccounts: accountParser.parseNumberOfAccounts(response),
    });
  }

  handleAccountsListError(error, status) {
    raise(FavouritesConstants.REQUEST_FAVOURITE_ACCOUNTS_FAILURE, {
      error,
      status,
    });
  }

  sortAccountList() {
    AppDispatcher.handleServerAction({
      actionType: FavouritesConstants.RESORT_ACCOUNT,
    });
  }

  resetErrorFlag() {
    AppDispatcher.handleServerAction({
      actionType: FavouritesConstants.REQUEST_ACCOUNTS_RESET_ERROR,
    });
  }

  handleSuccessResponseAddFavourite(account) {
    raise(FavouritesConstants.ADD_FAVOURITE_ACCOUNTS_SUCCESS, account);
  }

  handleErrorResponseAddFavourite(error, status) {
    raise(FavouritesConstants.ADD_FAVOURITE_ACCOUNTS_FAILURE, {
      error,
      status,
    });
  }

  handleSuccessResponseRemoveFavourite(id) {
    raise(FavouritesConstants.REMOVE_FAVOURITE_ACCOUNTS_SUCCESS, id);
  }

  handleErrorResponseRemoveFavourite(error, status) {
    raise(FavouritesConstants.REMOVE_FAVOURITE_ACCOUNTS_FAILURE, {
      error,
      status,
    });
  }

  handleErrorExceededMaxFavourites(error, status) {
    raise(FavouritesConstants.SET_FAVOURITE_ACCOUNTS_EXCEEDED_MAX, {
      error,
      status,
    });
  }

  handleSuccessResponseReorderFavourites(reorderedIds) {
    raise(FavouritesConstants.REORDER_FAVOURITE_ACCOUNTS_SUCCESS, reorderedIds);
  }

  handleErrorResponseReorderFavourites(error, status) {
    raise(FavouritesConstants.REORDER_FAVOURITE_ACCOUNTS_FAILURE, {
      error,
      status,
    });
  }

  addFavouriteAccount(account) {
    raise(FavouritesConstants.ADD_FAVOURITE_ACCOUNT, account);
  }

  removeFavouriteAccount(id) {
    raise(FavouritesConstants.REMOVE_FAVOURITE_ACCOUNT, id);
  }

  saveAccountPickerActions(actions) {
    raise(FavouritesConstants.SET_ACCOUNT_PICKER_ACTIONS, actions);
  }

  clearSelectedAccountId() {
    raise(FavouritesConstants.CLEAR_SELECTED_ACCOUNT_ID);
  }
  resetAccountDetailsLoadedFlag() {
    raise(FavouritesConstants.RESET_ACCOUNT_DETAILS_FLAG);
  }
}

export default new FavouritesActionCreator();
